<script>
  /**
   * @typedef {Object} Props
   * @property {number} [size=40] The width and height dimension for the icon
   * @property {string} [fill="#000000"] The color to fill the icon
   */

  /** @type {Props} */
  let { size = 40, fill = "#000000" } = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 48 48"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  role="img"
  aria-label="Right arrow icon"
>
  <path
    d="M12.6435 0.325482C12.8696 0.102784 13.1652 0 13.5304 0C13.8957 0 14.2261 0.102784 14.5217 0.325482L37.5652 23.1263C37.8609 23.349 38 23.6403 38 24C38 24.3597 37.8609 24.651 37.5652 24.8737L14.5217 47.6745C14.2261 47.8972 13.8957 48 13.5304 48C13.1652 48 12.8696 47.8972 12.6435 47.6745L10.4348 45.4989C10.1391 45.2934 10 45.0021 10 44.6424C10 44.2827 10.1391 43.9572 10.4348 43.666L30.4 24L10.4348 4.35118C10.1391 4.05996 10 3.73448 10 3.37473C10 3.01499 10.1391 2.72377 10.4348 2.50107L12.6435 0.325482Z"
    {fill}
  />
</svg>
